let namespace = 'monitorEngExceptionOrder_';

//直接dispatch 为同步方法，比如  dispatch({type:'login/set',payload:{loading:false}});
//store 使用了thunk中间件，以下方法均为异步加载。

const monitorEngExceptionOrderAc = {
    SET: (value) => (dispatch) => {
        dispatch({ type: namespace + 'forcedUpdate', payload: value })
    },
}

export {
    monitorEngExceptionOrderAc
}